<template>
  <div class="content-warp">
    <div class="content-panle bg-white">
      <div class="table-operation-area">
        <div class="btn-area-inline">
          <a-button type="primary" @click="()=>{addBlackModalVisible=true;}">
            {{$t('blackList.addListBtn')}}
          </a-button>
        </div>
        <a-form class="search-form" layout="inline" :form="listSearchForm" @submit.prevent="handleSearchBlackList">
          <a-form-item>
            <a-input 
              style="width: 320px"
              type="text"
              v-decorator="['remark']" 
              :placeholder="$t('blackList.searchRemarkTxt')" >
              <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)" />
            </a-input>
          </a-form-item>
          <a-form-item style="margin-right:0">
            <a-button type="primary" html-type="submit" :loading="loading">
              {{$t('blackList.searchBtn')}}
            </a-button>
          </a-form-item>
        </a-form>
      </div>

      <TableTips :total="pagination.total" />
      
      <a-row style="min-height: 550px;" :span="24">        
        <a-col style="padding: 5px;" :span="6" v-for="item in balckListData" :key="item.id">
          <a-card :bodyStyle="{padding: '15px 10px 7px 10px'}">

            <template slot="cover">
              <div class="card-cover-warp">
                <img class="card-cover-img" :src="item.scenePhotoUrl" @click="handleShowImg"/>
              </div>
            </template>
            
            <a-card-meta>
              <template slot="description">
                <a-row>
                  <a-col :xl="24" :xxl="10" class="black-info-item">
                    <label class="item-title">姓名：</label>
                    <span class="item-content" :title="item.name">{{item.name}}</span>
                  </a-col>
                  <a-col :xl="24" :xxl="14" class="black-info-item">
                    <label class="item-title">电话：</label>
                    <span class="item-content" :title="item.phone">{{item.phone}}</span>
                  </a-col>
                  <a-col :xl="24" :xxl="10" class="black-info-item">
                    <label class="item-title">证件类型：</label>
                    <span class="item-content" :title="item.idTypeName">{{item.idTypeName}}</span>
                  </a-col>
                  <a-col :xl="24" :xxl="14" class="black-info-item">
                    <label class="item-title">证件号码：</label>
                    <span class="item-content" :title="item.idNumber">{{item.idNumber}}</span>
                  </a-col>
                  <a-col :xxl="24" class="black-info-item">
                    <label class="item-title">备注：</label>
                    <span class="item-content" :title="item.remark">{{item.remark}}</span>
                  </a-col>
                  <a-col :xl="24" :xxl="10" class="black-info-item">
                    <label class="item-title">操作人员：</label>
                    <span class="item-content" :title="item.operatorName">{{item.operatorName}}</span>
                  </a-col>
                  <a-col :xl="24" :xxl="14" class="black-info-item">
                    <label class="item-title">操作时间：</label>
                    <span class="item-content" :title="item.createdAt">{{item.createdAt}}</span>
                  </a-col>
                </a-row>
              </template>
            </a-card-meta>
            <template slot="actions" class="ant-card-actions">
              <span @click="()=>{handleEditBlack(item)}"><a-icon type="edit" /> {{$t('blackList.listEditBtn')}} </span>   
              <span @click="()=>{handleDeleteBlack(item.id)}" class="card-delete-btn"><a-icon type="delete" /> {{$t('blackList.listRemoveBtn')}} </span>                  
            </template>
          </a-card>
        </a-col>
      </a-row>

      <a-pagination 
        v-if="pagination.total"
        style="text-align:right; padding-top:16px; padding-right:10px"
        :current="pagination.current" 
        :pageSize="pagination.pageSize"
        :total="pagination.total"
        @change="handlePageChange"
      />  
    </div>

    <!-- 新增黑名单 -->
    <a-modal
      :maskClosable="false"
      :title="isEditBalck ? $t('blackList.editModalTitle') : $t('blackList.addModalTitle')"
      :visible="addBlackModalVisible"
      :okText="$t('blackList.confirmBtn') "
      :cancelText="$t('blackList.cancelBtn') "
      @ok="handleAddBlackList"
      :confirmLoading="confirmBlackLoading"
      @cancel="()=>{addBlackModalVisible=false}"
      :afterClose="handleAddBlackModalHide"
    > 
      <a-form-model 
        ref="addBlackForm"
        :model="addBlackForm" 
        :rules="addBlackFormRules"
        :label-col="{ span: 6 }" 
        :wrapper-col="{ span: 18 }" 
      > 
        <!-- 姓名 -->
        <a-form-model-item :label="$t('blackList.nameTxt')" prop="name">
          <a-input 
            v-model="addBlackForm.name" 
            :placeholder="$t('blackList.nameTxt')"
          />
        </a-form-model-item>
        <!-- 电话 -->
        <a-form-model-item :label="$t('blackList.phoneTxt')" prop="phone">
          <a-input 
            v-model="addBlackForm.phone" 
            :placeholder="$t('blackList.phoneTxt')"
          />
        </a-form-model-item>
        <!-- 证件类型 -->
        <a-form-model-item :label="$t('blackList.idCardTypeTxt')" prop="idCardType">
          <a-select 
            v-model="addBlackForm.idCardType" 
            :placeholder="$t('blackList.idCardTypeTxt')"
            :options="enumsData.idType"
            @change="handleIdCardTypeChange"
          >
          </a-select>
        </a-form-model-item>
        <!-- 证件号 -->
        <a-form-model-item :label="$t('blackList.idNumberTxt')" prop="idNumber">
          <a-input 
            v-model="addBlackForm.idNumber" 
            :placeholder="$t('blackList.idNumberTxt')"
          />
        </a-form-model-item>
        <!-- 备注 -->
        <a-form-model-item required :label="$t('blackList.remarkTxt')" prop="remark">
          <a-input 
            v-model="addBlackForm.remark" 
            :placeholder="$t('blackList.remarkTxt')"
          />
        </a-form-model-item>
        <!-- 照片 -->
        <a-form-model-item required :label="$t('blackList.imageTxt')" prop="photo">
          <a-upload
              name="file"
              accept="image/jpeg,image/jpg,image/png"
              listType="picture"
              :fileList="addBlackForm.photo"
              v-model="addBlackForm.photo"
              :beforeUpload="handleBeforeUploadImg"
              @change="handleImageFileChange"
            > 
              <!-- :disabled="Boolean(editBlackId)" -->
              <a-button><a-icon :type="imgUploading?'loading':'upload'" /> {{$t('blackList.uploadImageBtn')}} </a-button>
              <div class="upload-image-tip">{{$t('blackList.uploadImageDesc')}}</div>
            </a-upload>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 查看照片 -->
    <a-modal
      class="show-img-modal"
      :title="$t('blackList.blackImageModal')" 
      :footer="null"
      :visible="showImgModalVisible"
      @cancel="()=>{showImgModalVisible=false}"
      :afterClose="()=>{showImgUrl=''}"
    >
      <a-card style="width: 100%;">
        <img
          slot="cover"
          alt="example"
          :src="showImgUrl"
        />
      </a-card>
    </a-modal>
  </div>
</template>

<script>
import TableTips from '@/components/TableTips';
import { getBlackList, createBlack, modifyBlack, deleteBlack } from '@/api/blackListMana'
import { uploadBase64Img } from '@/api/fileUpload'
import { checkIdNumberValid, compressImageFile } from '../../utils/utils'
import { mapState } from 'vuex'

export default {
  name: 'blackListManaIndex',
  components: { TableTips },
  data() {
    return {
      cardNum: 8,

      listSearchForm: this.$form.createForm(this),
      balckListData: [],
      searchRemark: '',
      pagination: {
        current: 1,
        pageSize: 8,
        total: 0
      },
      loading: false,

      addBlackModalVisible: false,

      isEditBalck: false,
      editBlackId: '',

      confirmBlackLoading: false,

      addBlackForm: {
        name: '',
        phone: '',
        idCardType: 1,
        idNumber: '',
        remark: '',
        photo: []
      },
      addBlackFormRules: this.getAddBlackFormRules(),

      imgUploading: false,

      showImgModalVisible: false,
      showImgUrl: ''
    }
  },
  computed: {
    ...mapState({
      enumsData: state => state.enumsStore.enumsData
    })
  },
  created() {
    this.getBlackList()
  },
  methods: {
    getAddBlackFormRules() {
      return {
        name: [
          // { required: true, message: this.$t('blackList.nameBlank') },
          { max: 20, message: this.$t('blackList.nameWarnning') }
        ],
        phone: [
          // { required: true, message: this.$t('blackList.phoneBlank') },
          // { pattern: /^1[3456789]\d{9}$/, message: this.$t('blackList.phoneWarnning') }
        ],
        idCardType: [
          // { required: true, message: this.$t('blackList.idCardTypeBlank') }
        ],
        idNumber: [
          // { required: true, message: this.$t('blackList.idNumberBlank') }
          { validator: this.validatorIdNumber, trigger: 'blur' }
        ],
        remark: [
          { required: true, message: this.$t('blackList.remarkBlank') },
          { max: 40, message: this.$t('blackList.remarkWarnning') }
        ],
        photo: [{ required: true, message: this.$t('blackList.imageBlank') }]
      }
    },
    // 搜索黑名单
    handleSearchBlackList(e) {
      this.listSearchForm.validateFields((err, values) => {
        if (!err) {
          // console.log('handleSearchBlackList', values);
          this.searchRemark = values.remark;
          this.pagination.current = 1;
          this.getBlackList();
        }
      });
    },

    // 获取黑名单
    async getBlackList() {
      try {
        this.loading = true;
        const res = await getBlackList({
          remark: this.searchRemark,
          page: this.pagination.current,
          perPage: this.pagination.pageSize
        })
        this.loading = false;

        this.balckListData = res.data.collection;
        this.pagination.total = res.data.size;
      } catch (error) {
        this.loading = false;
      }
    },
    // 点击分页时触发
    handlePageChange(page, pageSize) {
      // console.log('-------handlePageChange------', page, pageSize);
      this.pagination.current = page;
      this.getBlackList();
    },

    // 提交添加的黑名单
    handleAddBlackList() {
      this.$refs.addBlackForm.validate(async valid => {
        if (valid) {
          try {
            this.confirmBlackLoading = true;
            // console.log('-handleAddBlackList-', this.addBlackForm.photo)
            const res = this.isEditBalck 
              ? await modifyBlack({ 
                id: this.editBlackId,
                name: this.addBlackForm.name,
                phone: this.addBlackForm.phone,
                idTypeCode: this.addBlackForm.idCardType,
                idNumber: this.addBlackForm.idNumber,
                remark: this.addBlackForm.remark,
                scenePhotoUrl: this.addBlackForm.photo[0].url
              })
              : await createBlack({
                name: this.addBlackForm.name,
                phone: this.addBlackForm.phone,
                idTypeCode: this.addBlackForm.idCardType,
                idNumber: this.addBlackForm.idNumber,
                remark: this.addBlackForm.remark,
                scenePhotoUrl: this.addBlackForm.photo[0].url
              })
            this.addBlackModalVisible = false;

            this.$notification.success({
              message: this.isEditBalck ? this.$t('blackList.editSuccess') : this.$t('blackList.addSuccess'),
              duration: 2.5
            });
            this.handleAddBlackModalHide();
            this.getBlackList();
          } catch (error) {
            // console.log('-handleAddBlackList error-', error)
            this.addBlackModalVisible = false;
          }
        }
      })
    },

    // 提交图片前，验证图片大小和宽高，不符合就进行图片压缩
    async handleBeforeUploadImg(file) {
      // console.log('--handleBeforeUploadImg--', file)
      try {        
        this.imgUploading = true
        compressImageFile(file, this.handleUploadBannerImg)
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject()
      } catch (error) {
        this.imgUploading = false
        this.$message.error(this.$t('blackList.uploadFail'));
        return Promise.reject(error)
      }
    },
    // 上传黑名单图片
    async handleUploadBannerImg(image) {
      try {
        const base64Unhead = image.base64.replace(/^data:image\/\w+;base64,/, '')
        const res = await uploadBase64Img({ data: base64Unhead, suffix: 'jpg' })
        this.imgUploading = false;
        this.$message.success(`${image.name} ${this.$t('blackList.uploadSuccess')}`);

        this.addBlackForm.photo = [{
          ...image,
          url: res.data.collection[0]
        }]
        this.$refs.addBlackForm.validateField('photo')
      } catch (error) {
        this.$message.error(`${image.name} ${this.$t('blackList.uploadFail')}`);
        this.imgUploading = false;
      }
    },
    // 黑名单照片改变时
    handleImageFileChange(info) {
      if (info.file.status === 'removed') {
        this.addBlackForm.photo = []
      }
      return this.addBlackForm.photo
    },

    // 编辑黑名单
    handleEditBlack(data) {
      this.addBlackModalVisible = true;
      this.isEditBalck = true;
      this.editBlackId = data.id;
      this.addBlackForm = {
        name: data.name,
        phone: data.phone,
        idCardType: data.idTypeCode || 1,
        idNumber: data.idNumber,
        remark: data.remark,
        photo: [{
          uid: 'default',
          name: this.$t('blackList.imageTxt'),
          status: 'done',
          thumbUrl: data.scenePhotoUrl,
          url: data.scenePhotoUrl
          // response: { collection: [data.scenePhotoUrl] }
        }]
      }
    },
    // 关闭添加黑名单模态框
    handleAddBlackModalHide() {
      this.confirmBlackLoading = false;
      this.imgUploading = false;
      this.isEditBalck = false;
      this.editBlackId = '';
      this.addBlackForm = {
        name: '',
        phone: '',
        idCardType: 1,
        idNumber: '',
        remark: '',
        photo: []
      }
      this.$refs.addBlackForm.resetFields()
    },
    // 删除黑名单
    handleDeleteBlack(id) {
      this.$confirm({
        title: this.$t('blackList.removeWarning'),
        content: '',
        okText: this.$t('blackList.confirmBtn'),
        cancelText: this.$t('blackList.cancelBtn'),
        onOk: () => { this.deleteBlackRquest(id) },
        onCancel() {}
      });
    },
    async deleteBlackRquest(id) {
      try {
        await deleteBlack({ id })
        this.$notification.success({
          message: this.$t('blackList.removeSuccess'),
          duration: 2.5
        });
        this.getBlackList();
      } catch (error) {}
    },

    // 查看黑名单照片
    handleShowImg(e) {
      this.showImgUrl = e.target.src;
      this.showImgModalVisible = true;
    },

    // 证件类型改变时
    handleIdCardTypeChange(type) {
      this.idCardType = type
      this.$refs.addBlackForm.validateField('idNumber')
    },

    // 若证件类型为身份证，验证身份证
    validatorIdNumber(rule, value, callback) {
      if (value && this.addBlackForm.idCardType === 1) {
        checkIdNumberValid(value) 
          ? callback()
          : callback(this.$t('blackList.idNumberWarnning'));
        return
      }
      callback()
    }
  }
}
</script>

<style>
  .ant-card-body{
    padding: 15px;
  }
  .show-img-modal .ant-modal{
    top: 30px
  }
</style>
<style scoped>
.panle-item{
  position: relative;
}
.card-cover-warp{
  text-align: center;
  /* height: 160px; */
  height: 200px;
  overflow: hidden;
}
.card-cover-img{
  /* min-height: 100%; */
  /* width: 100%; */
  height: 100%;
  width: auto;
  cursor: pointer;
  /* margin-top: -35%; */
}
.card-delete-btn:hover{
  color:#F5222D
}

.black-info-item{
  margin-bottom: 8px;
  font-size: 12px;
}
.black-info-item .item-title{
  width: 85px;
  display: inline-block;
  text-align: right;
}
.black-info-item .item-content{
  width: calc(100% - 85px);
  color: rgba(0, 0, 0, 0.85);
  display: inline-block;
  word-break: break-all;
  vertical-align: top;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.upload-image-tip{
  font-size: 12px;
  line-height: 20px;
  margin-top: 5px;
  color: rgba(0,0,0,.45);
}
</style>